import { tokenAtom, useAtom } from '@/store';
import request from './request';

export const useToken = (): [string, (token: string) => void] => {
  const [token, setToken] = useAtom(tokenAtom);

  request.setBearer(token);

  return [token, setToken];
};
